import { Box, CircularProgress, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { AttachmentIcon, TextIcon } from "../../assets/Icon/OrderDetailIcon";
import img1 from "../../assets/Images/messageprofile.svg";

interface messageFormtype {
  isReply?: boolean;
  message?: string;
  handleSend?: any;
  fetchMessgaeData?: any;
  sentMessage?: any;
  isPadding?: boolean;
  sentData?: any;
  sending?: boolean;
}

const MessageBox = (props: messageFormtype) => {
  const {
    isReply,
    message,
    handleSend,
    fetchMessgaeData,
    sentMessage,
    sentData,
    sending,
  } = props;

  const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
  const formatDateWithMoment = (dateStr: string) => {
    return dateStr
      ? moment(`${dateStr}Z`).format("MMM Do [at] h:mm a")
      : moment().format("MMM Do [at] h:mm a");
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const editor = document.querySelector(".ql-editor");
      if (editor) {
        editor.setAttribute("dir", "ltr");
        const uls = editor.querySelectorAll("ul");
        const ols = editor.querySelectorAll("ol");
        uls.forEach((ul) => ul.setAttribute("dir", "ltr"));
        ols.forEach((ol) => ol.setAttribute("dir", "ltr"));
      }
    });

    const targetNode = document.querySelector(".ql-editor");
    if (targetNode) {
      observer.observe(targetNode, { childList: true, subtree: true });
    }

    return () => observer.disconnect();
  }, []);

  const containerRef = useRef<HTMLDivElement | null>(null);

  const scrollContainerToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  };

  const [combinedMessages, setCombinedMessages] =
    useState<any[]>(fetchMessgaeData);

  useEffect(() => {
    scrollContainerToBottom();
  }, [combinedMessages]);

  useEffect(() => {
    if (fetchMessgaeData) {
      setCombinedMessages(fetchMessgaeData);
    }
  }, [fetchMessgaeData]);

  useEffect(() => {
    if (!sending) {
      setCombinedMessages((prevState) =>
        prevState.map((msg) =>
          msg.isSending ? { ...msg, isSending: false } : msg
        )
      );
    }
  }, [sending]);


  return (
    <Box
      ref={containerRef}
      sx={{ maxHeight: "450px", overflowY: "auto" }}
      id="messgeContent"
    >
      {combinedMessages?.map((messageItem: any, index: number) => (
        <Box
          key={messageItem?.id || index}
          sx={{
            borderBottom: "2px solid #EAF1FA",
            padding: 2,
          }}
        >
          {/* Sender Info */}
          <Box
            sx={{
              display: "flex",
              gap: "30px",
              padding: 2,
              marginTop: index !== 0 ? "20px" : 0,
            }}
          >
            <Box
              sx={{
                height: "50px",
                width: "50px",
                background: "#9FB9D5",
                borderRadius: "4.72px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <Typography
                sx={{ fontSize: "16px", fontWeight: 600, color: "#FFFFFF" }}
              >
                {messageItem?.sender_name
                  ?.trim()
                  .split(/\s+/)
                  .map((word: string) => word[0]?.toUpperCase())
                  .join("")}
              </Typography>
              <Box
                sx={{
                  position: "absolute",
                  bottom: "-12px",
                  right: "-17px",
                }}
              >
                <img src={img1} alt="avatar tag" />
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexGrow: 1,
              }}
            >
              <Box>
                <Typography
                  sx={{ fontSize: "18px", fontWeight: 600, color: "#010407" }}
                >
                  {messageItem?.sender_name}
                </Typography>
                <Typography
                  sx={{ fontSize: "14px", fontWeight: 400, color: "#6C6F71" }}
                >
                  {formatDateWithMoment(messageItem?.created_at)}
                </Typography>
              </Box>

              {isReply && (
                <Box>
                  <TextIcon />
                </Box>
              )}
            </Box>
          </Box>

          {/* Message Body and Attachments */}
          <Box
            sx={{
              padding: 2,
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            <Box>
              {messageItem?.message && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "20px",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    wordBreak: "break-word",
                  }}
                >
                  {/* Message text */}
                  <Box
                    sx={{
                      flex: 1,
                      wordWrap: "break-word",
                      "& ul": {
                        listStyleType: "disc",
                        paddingLeft: "20px",
                      },
                      "& ol": {
                        listStyleType: "decimal",
                        paddingLeft: "20px",
                      },
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#6C6F71",
                      lineHeight: "28px",
                    }}
                    dangerouslySetInnerHTML={{ __html: messageItem.message }}
                  />
                  <Box></Box>
                </Box>
              )}

              {/* Attachments */}
              {!isReply && messageItem?.files?.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    justifyContent: "space-between",
                  }}
                >
                  <>
                    {messageItem?.files?.map(
                      (fileData: any, fileIndex: number) => {
                        const isImage =
                          fileData?.file &&
                          (fileData?.file?.endsWith(".jpg") ||
                            fileData?.file?.endsWith(".png") ||
                            fileData?.file?.endsWith(".jpeg") ||
                            fileData?.file?.endsWith(".gif"));

                      
                        return (
                          <Box
                            key={fileData?.id || fileData?.file}
                            sx={{
                              display: "flex",
                              gap: 1,
                              alignItems: "center",
                            }}
                          >
                            {(fileData?.file || fileData?.name) && (
                              <Box>
                                <AttachmentIcon />
                              </Box>
                            )}
                            <Typography
                              sx={{
                                fontSize: "16px",
                                fontWeight: 500,
                                color: "#2977CC",
                              }}
                            >
                              <a
                                href={`${baseUrl}${fileData?.file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <span>
                                  {fileData?.file
                                    ? fileData?.file?.split("/").pop()
                                    : fileData?.name}
                                </span>
                              </a>
                            </Typography>
                          </Box>
                        );
                      }
                    )}
                  </>
                </Box>
              )}
            </Box>
            {sending && index === combinedMessages.length - 1 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 1,
                  alignItems: "center",
                }}
              >
                <CircularProgress size={20} thickness={5} />
                <Typography variant="caption">Sending...</Typography>
              </Box>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default MessageBox;
